import React from 'react'
import withIconStyles from '@edulastic/icons/src/HOC/withIconStyles'
import SVG from '@edulastic/icons/src/common/SVG'

const IconImage = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="15.773"
    height="13.113"
    viewBox="0 0 15.773 13.113"
    {...props}
  >
    <g transform="translate(0 -43.163)">
      <g transform="translate(0 43.163)">
        <g transform="translate(0 0)">
          <path
            d="M15.222,43.163H.55a.55.55,0,0,0-.55.55V55.726a.55.55,0,0,0,.55.55H15.222a.55.55,0,0,0,.55-.55V43.713A.55.55,0,0,0,15.222,43.163Zm-.55,12.013H1.1V44.263H14.672V55.176Z"
            transform="translate(0 -43.163)"
          />
        </g>
      </g>
      <g transform="translate(3.87 45.602)">
        <g transform="translate(0 0)">
          <path
            d="M127.636,122.344a2.017,2.017,0,1,0,2.017,2.017A2.02,2.02,0,0,0,127.636,122.344Zm0,2.934a.917.917,0,1,1,.917-.917A.918.918,0,0,1,127.636,125.278Z"
            transform="translate(-125.619 -122.344)"
          />
        </g>
      </g>
      <g transform="translate(3.237 50.077)">
        <path
          d="M112.713,267.658a.549.549,0,0,0-.549.054l-7.079,5.08.642.894,6.82-4.895,4.295,1.958.457-1Z"
          transform="translate(-105.085 -267.608)"
        />
      </g>
      <g transform="translate(0.296 49.387)">
        <g transform="translate(0 0)">
          <path
            d="M.757,55.545h0l-.2-5.484,6.688,3.672,3.391-2.8,4.734,2.109v2.719H1.382"
            transform="translate(-0.297 -49.387)"
          />
          <rect
            width="1.1"
            height="7.277"
            transform="translate(0 0.976) rotate(-62.53)"
            fill="#434b5d"
          />
        </g>
      </g>
    </g>
  </SVG>
)

export default withIconStyles(IconImage)
